import { computed, Directive, effect, ElementRef, inject, input } from '@angular/core';
import { FontAwesomeStyle } from './font-awesome.type';

@Directive({
    selector: '[fa]',
})
export class FontAwesomeDirective {
    private oldValues: FontAwesomeStyle|'' = '';
    private element = inject(ElementRef);
    fa = input.required<FontAwesomeStyle>();
    private classes = computed(() => [
        this.fa().split(' ').map((s: string) => `fa-${s}`),
    ]);

    constructor() {
        effect(() => {
            this.element.nativeElement.classList.remove(
                ...this.oldValues.split(' ').map((s: string) => `fa-${s}`),
            );
            this.oldValues = this.fa();
            this.element.nativeElement.classList.add(this.classes());
        });
    }
}
